import { PracticePayerMappingsMode } from "@common-shared/config/practice.config"

import { ISelectTabsItem } from "../types/objects.types"
import { PayerMappingsExportRowKey } from "../types/payerMappings.types"
import { GENERAL_CONFIG } from "./general.config"

export const PAYER_MAPPINGS_CONFIG = {
    csvHeaderRowIndex: 0,

    /** Page size when exporting mappings to CSV (API max is 200). */
    csvExportPageSize: 200,

    csvExportBaseFileName: "payer-mappings",

    // Shown while the bulk upsert runs and in the confirmation before it, so the
    // wait is expected rather than mistaken for a hang
    bulkUpsertDurationNotice:
        "Saving these mappings can take several minutes. Please keep this tab open until it completes.",

    listPerPageStorageKey:
        "payerMappings" +
        GENERAL_CONFIG.browserStorageKeys.policiesResultsPerPageSuffix,

    reviewListPerPageStorageKey:
        "payerMappingsReview" +
        GENERAL_CONFIG.browserStorageKeys.policiesResultsPerPageSuffix,

    get csvTemplateUrl(): string {
        const baseAssetsUrl = import.meta.env.VITE_S3_ASSETS_BASE_URL

        return `${baseAssetsUrl}/nirvana-payer-mappings-template-v1.0.csv`
    },

    get csvHeaderToKey(): Record<string, PayerMappingsExportRowKey> {
        return {
            "Payer Name": "externalName",
            "Payer ID": "externalPayerId",
            "Nirvana Payer ID": "payerId",
        }
    },

    get payerMappingsModeMapping(): Record<PracticePayerMappingsMode, string> {
        return {
            [PracticePayerMappingsMode.PASSTHROUGH]: "Passthrough",
            [PracticePayerMappingsMode.MANAGED]: "Managed",
        }
    },

    get payerMappingsModeDescription(): Record<
        PracticePayerMappingsMode,
        string
    > {
        return {
            [PracticePayerMappingsMode.PASSTHROUGH]:
                "Passthrough means that checks for this practice are assumed to use Nirvana payer IDs.",
            [PracticePayerMappingsMode.MANAGED]:
                "Managed means that checks for this practice will be mapped to Nirvana payer IDs via provided payer mappings.",
        }
    },

    get payerMappingsModeOptions(): ISelectTabsItem<PracticePayerMappingsMode>[] {
        return [
            {
                value: PracticePayerMappingsMode.PASSTHROUGH,
                label: this.payerMappingsModeMapping[
                    PracticePayerMappingsMode.PASSTHROUGH
                ],
            },
            {
                value: PracticePayerMappingsMode.MANAGED,
                label: this.payerMappingsModeMapping[
                    PracticePayerMappingsMode.MANAGED
                ],
            },
        ]
    },
}
